/* SOMYA — script unique, chargé en defer. Menu, panier (AJAX), page produit, couches, sticky. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const devise = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100);
  const verrou = (on) => { document.documentElement.style.overflow = on ? 'hidden' : ''; };

  /* ---------- Menu latéral ---------- */
  const menu = $('[data-sy-menu]');
  if (menu) {
    const burger = $('[data-sy-ouvre-menu]');
    const bascule = (o) => { menu.hidden = !o; burger && burger.setAttribute('aria-expanded', o); verrou(o); if (o) ($('.sy-croix', menu) || menu).focus(); };
    burger && burger.addEventListener('click', () => bascule(true));
    menu.addEventListener('click', (e) => { if (e.target.closest('[data-sy-ferme-menu]')) bascule(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) bascule(false); });
  }

  /* ---------- Panier ---------- */
  const panier = $('[data-sy-panier]');
  const majCompteur = (n) => $$('[data-sy-compteur]').forEach((el) => { el.textContent = n; el.hidden = !n; });
  const rafraichir = async () => {
    if (!panier) return;
    const corps = $('[data-sy-corps]', panier);
    const r = await fetch(racine + '?section_id=somya-panier-contenu', { headers: { Accept: 'text/html' } });
    if (!r.ok) return;
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const neuf = $('[data-sy-contenu]', doc);
    if (neuf && corps) { corps.innerHTML = ''; corps.appendChild(neuf); majCompteur(Number(neuf.dataset.syNombre || 0)); }
  };
  const ouvrirPanier = () => { if (!panier) { location.href = racine + 'cart'; return; } panier.hidden = false; verrou(true); ($('.sy-croix', panier) || panier).focus(); };
  const fermerPanier = () => { if (!panier) return; panier.hidden = true; verrou(false); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-sy-ouvre-panier]')) { e.preventDefault(); rafraichir(); ouvrirPanier(); }
    if (e.target.closest('[data-sy-ferme-panier]')) fermerPanier();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panier && !panier.hidden) fermerPanier(); });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-sy-maj]');
    if (!b) return;
    const zone = b.closest('[data-sy-panier], [data-sy-panier-page]');
    zone && zone.classList.add('est-charge');
    await fetch(racine + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.syLigne), quantity: Number(b.dataset.syMaj) }) });
    if (zone && zone.hasAttribute('data-sy-panier-page')) { location.reload(); return; }
    await rafraichir();
    zone && zone.classList.remove('est-charge');
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = (btn && btn.querySelector('[data-sy-ajout-texte]')) || btn;
    const avant = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = (window.cmStrings || {}).ajout || 'Ajout…';
    try {
      const fd = new FormData(form);
      fd.append('sections', 'somya-panier-contenu');
      const r = await fetch(racine + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!r.ok) { const err = await r.json().catch(() => ({})); if (label) label.textContent = err.description || (window.cmStrings || {}).indisponible || 'Indisponible'; setTimeout(() => { if (label) label.textContent = avant; if (btn) btn.disabled = false; }, 2200); return; }
      const data = await r.json();
      if (panier && data.sections && data.sections['somya-panier-contenu']) {
        const doc = new DOMParser().parseFromString(data.sections['somya-panier-contenu'], 'text/html');
        const neuf = $('[data-sy-contenu]', doc); const corps = $('[data-sy-corps]', panier);
        if (neuf && corps) { corps.innerHTML = ''; corps.appendChild(neuf); majCompteur(Number(neuf.dataset.syNombre || 0)); }
      } else { await rafraichir(); }
      if (label) label.textContent = (window.cmStrings || {}).ajoute || 'Ajouté ✓';
      ouvrirPanier();
    } catch (_) { if (label) label.textContent = (window.cmStrings || {}).reessayez || 'Réessayez'; }
    finally { setTimeout(() => { if (label) label.textContent = avant; if (btn) btn.disabled = false; }, 1200); }
  });

  /* ---------- Page produit ---------- */
  const pp = $('[data-sy-produit]');
  if (pp) {
    let variantes = [];
    try { variantes = JSON.parse($('[data-sy-variantes]', pp).textContent); } catch (_) {}
    const piste = $('[data-sy-piste]', pp), vues = $$('[data-sy-vue]', pp), vignettes = $$('[data-sy-vignette]', pp), points = $$('[data-sy-point]', pp);
    let idx = 0;
    const marquer = (i) => { idx = i; vignettes.forEach((v, k) => { v.classList.toggle('est-actif', k === i); v.setAttribute('aria-selected', k === i); }); points.forEach((p, k) => p.classList.toggle('est-actif', k === i)); const vg = vignettes[i]; if (vg && vg.parentElement) { const c = vg.parentElement; c.scrollTo({ left: vg.offsetLeft - c.clientWidth / 2 + vg.clientWidth / 2, behavior: 'smooth' }); } };
    const aller = (i) => { if (!vues.length) return; i = (i + vues.length) % vues.length; piste.scrollTo({ left: vues[i].offsetLeft, behavior: 'smooth' }); marquer(i); };
    const champId = $('[data-sy-id-variante]', pp), prix = $('[data-sy-prix]', pp), barre = $('[data-sy-prix-barre]', pp), remise = $('[data-sy-remise]', pp);
    const bouton = $('[data-sy-ajout]', pp), btnTexte = $('[data-sy-ajout-texte]', pp), alerte = $('[data-sy-stock]', pp);
    const stickyPrix = $('[data-sy-sticky-prix]');
    const choisis = () => $$('[data-sy-valeur]:checked', pp).sort((a, b) => a.dataset.syIndex - b.dataset.syIndex).map((i) => i.value);
    const majDispo = () => {
      const c = choisis();
      $$('[data-sy-valeur]', pp).forEach((input) => {
        const t = [...c]; t[Number(input.dataset.syIndex)] = input.value;
        const v = variantes.find((va) => t.every((val, i) => va.options[i] === val));
        input.nextElementSibling && input.nextElementSibling.classList.toggle('est-epuise', !!v && !v.available);
      });
    };
    const majAffichage = () => {
      const c = choisis();
      c.forEach((val, i) => { const el = $('[data-sy-choix="' + i + '"]', pp); if (el) el.textContent = val.replace(' x ', ' × ').replace(' x ', ' × ').replace(' cm', ''); });
      const v = variantes.find((va) => c.every((val, i) => va.options[i] === val));
      if (!v) { bouton.disabled = true; btnTexte.textContent = (window.cmStrings || {}).indisponible || 'Indisponible'; alerte.hidden = false; return; }
      champId.value = v.id;
      prix.textContent = devise(v.price);
      if (stickyPrix) stickyPrix.textContent = devise(v.price);
      if (barre && remise) { if (v.compare_at_price && v.compare_at_price > v.price) { barre.textContent = devise(v.compare_at_price); barre.hidden = false; remise.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; remise.hidden = false; } else { barre.hidden = true; remise.hidden = true; } }
      bouton.disabled = !v.available; btnTexte.textContent = v.available ? ((window.cmStrings || {}).addToCart || 'Ajouter au panier') : ((window.cmStrings || {}).soldOut || 'Rupture de stock'); alerte.hidden = v.available;
      const u = new URL(location); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      if (v.featured_media && v.featured_media.id) { const k = vues.findIndex((el) => el.dataset.syMedia === String(v.featured_media.id)); if (k >= 0) aller(k); }
      majDispo();
    };
    pp.addEventListener('change', (e) => {
      if (!e.target.matches('[data-sy-valeur]')) return;
      const dd = e.target.closest('[data-sy-dd]'); if (!dd) return;
      const rond = $('[data-sy-dd-rond]', dd), src = e.target.nextElementSibling && e.target.nextElementSibling.querySelector('[data-sy-img]');
      if (rond) { rond.innerHTML = src ? '<img src="' + src.dataset.syImg + '" alt="" width="40" height="40">' : ''; if (!src) { const r = e.target.nextElementSibling.querySelector('.sy-pp__rond'); if (r) rond.style.background = getComputedStyle(r.firstElementChild).backgroundColor; } }
      setTimeout(() => dd.removeAttribute('open'), 120);
    });
    pp.addEventListener('change', (e) => { if (e.target.matches('[data-sy-valeur]')) majAffichage(); });
    $$('[data-sy-qte]', pp).forEach((b) => b.addEventListener('click', () => { const ch = $('[data-sy-qte-champ]', pp); ch.value = Math.max(1, (parseInt(ch.value, 10) || 1) + (b.dataset.syQte === '+' ? 1 : -1)); }));
    majDispo();

    vignettes.forEach((v, i) => v.addEventListener('click', () => aller(i)));
    $$('[data-sy-fleche]', pp).forEach((f) => f.addEventListener('click', () => aller(idx + (f.dataset.syFleche === 'd' ? 1 : -1))));
    if (piste) { let t; piste.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => { const i = Math.round(piste.scrollLeft / piste.clientWidth); if (i !== idx) marquer(i); }, 80); }, { passive: true }); }

    const guide = $('[data-sy-guide]');
    if (guide) { $$('[data-sy-ouvre-guide]').forEach((b) => b.addEventListener('click', () => guide.showModal())); $$('[data-sy-ferme-guide]', guide).forEach((b) => b.addEventListener('click', () => guide.close())); guide.addEventListener('click', (e) => { if (e.target === guide) guide.close(); }); }

    const sticky = $('[data-sy-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver((es) => es.forEach((en) => sticky.classList.toggle('est-visible', !en.isIntersecting && en.boundingClientRect.top < 0))).observe(bouton);
      $('[data-sy-sticky-btn]', sticky).addEventListener('click', () => { bouton.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }

  /* ---------- Avis : voir plus ---------- */
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-sy-plus-avis]'); if (!b) return; $$('.sy-avis__carte.est-cache').forEach((c) => c.classList.remove('est-cache')); b.hidden = true; });

  /* ---------- Couches interactives ---------- */
  $$('[data-sy-couches]').forEach((sec) => {
    const items = $$('[data-sy-couche]', sec), pts = $$('[data-sy-point-couche]', sec), bulle = $('[data-sy-bulle]', sec);
    const act = (n) => { items.forEach((i) => i.classList.toggle('est-actif', i.dataset.syCouche === n)); pts.forEach((p) => p.classList.toggle('est-actif', p.dataset.syPointCouche === n)); const it = items.find((i) => i.dataset.syCouche === n); if (bulle && it) bulle.lastChild.textContent = n + '. ' + it.dataset.syNom; };
    items.forEach((i) => i.addEventListener('click', () => act(i.dataset.syCouche)));
    pts.forEach((p) => p.addEventListener('click', () => { act(p.dataset.syPointCouche); const it = items.find((i) => i.dataset.syCouche === p.dataset.syPointCouche); if (it && window.innerWidth < 900) it.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }));
    act('1');
  });

  fetch(racine + 'cart.js').then((r) => r.ok && r.json()).then((c) => c && majCompteur(c.item_count)).catch(() => {});
})();
